export const CATEGORIES = [
  {
    id: 'suppressors',
    name: 'Suppressors',
    slug: 'suppressors',
    tagline: 'Ultra Compact Fighting Suppressors',
    description: 'Hearing-safe performance without the bulk. Our ultra compact suppressors are engineered for hard use on SBRs, pistols, and hunting rifles.',
    image: 'https://wittmachine.net/wp-content/uploads/2022/08/suppressorproductmain.png',
    nfaRequired: true,
  },
  {
    id: 'sme',
    name: 'Sound Mitigation Equipment',
    slug: 'sound-mitigation-equipment',
    tagline: 'Directional Blast Control',
    description: 'Sound Mitigation Equipment directs blast forward and reduces perceived noise without NFA registration. A practical solution for tactical shooters.',
    image: 'https://wittmachine.net/wp-content/uploads/2025/09/sound.webp',
    nfaRequired: false,
  },
  {
    id: 'clamp-ons',
    name: 'Clamp-On Muzzle Brakes',
    slug: 'clamp-ons',
    tagline: 'No Threading Required',
    description: 'Our clamp-on muzzle brakes reduce recoil by 60%+ without any barrel modification. Custom-fit to your barrel diameter.',
    image: 'https://wittmachine.net/wp-content/uploads/2025/09/custombrake.webp',
    nfaRequired: false,
  },
  {
    id: 'muzzle-devices',
    name: 'Threaded Muzzle Brakes',
    slug: 'muzzle-devices',
    tagline: 'Muzzle Rise Eliminated',
    description: 'Thread-on Muzzle Rise Eliminators independently tested to virtually eliminate muzzle rise. Custom-machined to your thread spec.',
    image: 'https://wittmachine.net/wp-content/uploads/2022/07/prod1.jpg',
    nfaRequired: false,
  },
];

export const PRODUCTS = [
  // ===== SUPPRESSORS =====
  {
    id: 'ravener-12',
    slug: 'ravener-12-gauge-suppressor',
    name: 'The Ravener-12',
    subtitle: '12 Gauge Suppressor',
    category: 'suppressors',
    price: 699.99,
    priceRange: null,
    rating: 4.9,
    reviewCount: 24,
    badge: 'Featured',
    image: 'https://wittmachine.net/wp-content/uploads/2026/01/Ravener4NewSize.png',
    images: [
      'https://wittmachine.net/wp-content/uploads/2026/01/Ravener4NewSize.png',
      'https://wittmachine.net/wp-content/uploads/2025/10/Ravener5-150x177.png',
    ],
    description: 'The Ravener-12 is Witt Machine\'s premiere 12-gauge shotgun suppressor. Built to withstand the extreme pressure of 12-gauge loads, this suppressor delivers hearing-safe performance without sacrificing reliability or durability. Perfect for hunting, home defense, and tactical applications.',
    shortDesc: 'Hearing-safe 12-gauge performance built for extreme pressure and hard use.',
    specs: {
      'Caliber': '12 Gauge',
      'NFA Item': 'Yes — All NFA Rules Apply',
      'Mounting': 'Direct Thread',
      'Finish Options': 'Cerakote / Stainless',
      'Material': 'Stainless Steel',
      'Shipping': 'UPS Required',
    },
    features: [
      'Hearing-safe on standard 12-gauge loads',
      'Reduces muzzle flash significantly',
      'Durable stainless steel construction',
      'Available with Cerakote finish',
      'NFA registered item — all NFA rules apply',
    ],
    useCases: ['Hunting', 'Home Defense', 'Tactical'],
    inStock: true,
    featured: true,
    nfaItem: true,
    shippingNote: '*Choose UPS Shipping at Checkout*',
  },
  {
    id: 'mod-1-qd',
    slug: 'mod-1-quick-disconnect',
    name: 'Mod-1 Quick Disconnect',
    subtitle: 'Ultra Compact Suppressor',
    category: 'suppressors',
    price: 499.00,
    priceRange: null,
    rating: 5.0,
    reviewCount: 47,
    badge: 'Best Seller',
    image: 'https://wittmachine.net/wp-content/uploads/2025/09/mod-1-quick-disconnect-ultra-compact-suppressor.webp',
    images: [
      'https://wittmachine.net/wp-content/uploads/2025/09/mod-1-quick-disconnect-ultra-compact-suppressor.webp',
      'https://wittmachine.net/wp-content/uploads/2022/08/witt-machine-mod-1-quick-disconnect-ultra-compact-150x192.jpg',
    ],
    description: 'The Mod-1 Quick Disconnect is the pinnacle of our ultra compact suppressor line. The proprietary quick-detach system allows for rapid deployment and removal without tools. Hearing safe on 5.56 SBRs as short as 11.5 inches. Pairs with the included Rearden Mfg brake for the cleanest installation.',
    shortDesc: 'Quick-detach ultra compact suppressor — hearing safe on 11.5" 5.56 SBRs.',
    specs: {
      'Caliber': '5.56 / .223',
      'NFA Item': 'Yes — All NFA Rules Apply',
      'Mounting': 'Quick Disconnect (included brake)',
      'Barrel Rating': 'Hearing safe at 11.5"',
      'Finish Options': 'Cerakote Available',
      'Material': 'Stainless Steel',
    },
    features: [
      'Hearing safe on 11.5" 5.56 SBR barrel',
      'Tool-free quick disconnect mount',
      'Ultra compact form factor',
      'Full-auto rated construction',
      'Includes Rearden Mfg muzzle brake',
    ],
    useCases: ['Tactical', 'Home Defense', 'Range', 'Truck Gun'],
    inStock: true,
    featured: true,
    nfaItem: true,
    shippingNote: '*Choose UPS Shipping at Checkout*',
  },
  {
    id: 'big-body-tu-tu-three',
    slug: 'big-body-tu-tu-three',
    name: 'The Big Body Tu-Tu-Three',
    subtitle: 'Ultra Compact Suppressor',
    category: 'suppressors',
    price: 299.00,
    priceRange: null,
    rating: 5.0,
    reviewCount: 38,
    badge: 'Top Value',
    image: 'https://wittmachine.net/wp-content/uploads/2025/09/the-big-body-tu-tu-three-ultra-compact-suppressor.webp',
    images: [
      'https://wittmachine.net/wp-content/uploads/2025/09/the-big-body-tu-tu-three-ultra-compact-suppressor.webp',
      'https://wittmachine.net/wp-content/uploads/2022/08/witt-machine-the-big-body-tu-tu-three-ultra-compac6-150x192.jpg',
    ],
    description: 'The Big Body Tu-Tu-Three (.223/5.56) ultra compact fighting suppressor delivers serious hearing protection in a package that keeps your rifle short and maneuverable. Built for the shooter who demands performance without the premium price tag.',
    shortDesc: 'Maximum value ultra compact suppressor for .223/5.56 platforms.',
    specs: {
      'Caliber': '.223 / 5.56',
      'NFA Item': 'Yes — All NFA Rules Apply',
      'Mounting': 'Direct Thread',
      'Type': 'Ultra Compact',
      'Finish Options': 'Cerakote / Stainless',
      'Material': 'Stainless Steel',
    },
    features: [
      'Ultra compact fighting configuration',
      'Reduced muzzle flash and noise',
      'Durable stainless construction',
      'Compatible with multiple mounting options',
    ],
    useCases: ['Tactical', 'Hunting', 'Range', 'SHTF'],
    inStock: true,
    featured: true,
    nfaItem: true,
    shippingNote: '*Choose UPS Shipping at Checkout*',
  },
  {
    id: 'dirty-30',
    slug: 'dirty-30-compact-suppressor',
    name: 'The Dirty .30',
    subtitle: '30 Cal Compact Suppressor',
    category: 'suppressors',
    price: 299.00,
    priceRange: null,
    rating: 5.0,
    reviewCount: 29,
    badge: null,
    image: 'https://wittmachine.net/wp-content/uploads/2025/09/the-big-body-tu-tu-three-ultra-compact-suppressor-1.webp',
    images: [
      'https://wittmachine.net/wp-content/uploads/2025/09/the-big-body-tu-tu-three-ultra-compact-suppressor-1.webp',
      'https://wittmachine.net/wp-content/uploads/2022/08/30cal-compact-supp-6-150x100.jpg',
    ],
    description: 'The Dirty .30 is our compact 30-caliber suppressor designed for the hunter and hard-use shooter. Strong enough for any .30 caliber hunting load — from 300 Blackout to .308 Winchester — this suppressor will protect your ears in the backcountry without slowing you down.',
    shortDesc: 'Compact 30 cal suppressor for hunting and tactical .308/.300BLK platforms.',
    specs: {
      'Caliber': '.30 Caliber',
      'NFA Item': 'Yes — All NFA Rules Apply',
      'Mounting': 'Direct Thread',
      'Compatible': '.308 Win, .300BLK, .30-06 and more',
      'Finish Options': 'Cerakote / Stainless',
      'Material': 'Stainless Steel',
    },
    features: [
      'Rated for full .30 caliber spectrum',
      'Compact backcountry configuration',
      'Hearing safe performance',
      'Rugged stainless construction',
    ],
    useCases: ['Hunting', 'Tactical', 'Long Range'],
    inStock: true,
    featured: false,
    nfaItem: true,
    shippingNote: '*Choose UPS Shipping at Checkout*',
  },
  {
    id: 'freakin-45',
    slug: 'freakin-45-ultra-compact',
    name: 'The Freakin 45',
    subtitle: 'Ultra Compact Suppressor',
    category: 'suppressors',
    price: 299.00,
    priceRange: null,
    rating: 4.8,
    reviewCount: 22,
    badge: null,
    image: 'https://wittmachine.net/wp-content/uploads/2025/09/freakin45.webp',
    images: [
      'https://wittmachine.net/wp-content/uploads/2025/09/freakin45.webp',
      'https://wittmachine.net/wp-content/uploads/2022/08/witt-machine-the-freakin45-ultra-compact-suppresso2-150x192.jpg',
    ],
    description: 'The Freakin 45 brings ultra compact suppressor performance to your .45 ACP platform. Whether you\'re running a 1911, a Glock 21, or a .45 ACP carbine, this suppressor keeps noise down and your setup maneuverable.',
    shortDesc: 'Ultra compact .45 ACP suppressor for pistols and carbines.',
    specs: {
      'Caliber': '.45 ACP',
      'NFA Item': 'Yes — All NFA Rules Apply',
      'Mounting': 'Direct Thread',
      'Type': 'Ultra Compact',
      'Finish Options': 'Cerakote / Stainless',
      'Material': 'Stainless Steel',
    },
    features: [
      '.45 ACP caliber rated',
      'Ultra compact for pistol use',
      'Subsonic .45 ACP hearing protection',
      'Durable stainless steel construction',
    ],
    useCases: ['Home Defense', 'Tactical', 'Range'],
    inStock: true,
    featured: false,
    nfaItem: true,
    shippingNote: '*Choose UPS Shipping at Checkout*',
  },
  {
    id: 'naughty-9',
    slug: 'naughty-9-9mm-suppressor',
    name: 'The Naughty 9',
    subtitle: '9mm Ultra Compact Suppressor',
    category: 'suppressors',
    price: 299.00,
    priceRange: null,
    rating: 4.9,
    reviewCount: 33,
    badge: null,
    image: 'https://wittmachine.net/wp-content/uploads/2025/09/naughty9.webp',
    images: [
      'https://wittmachine.net/wp-content/uploads/2025/09/naughty9.webp',
      'https://wittmachine.net/wp-content/uploads/2022/08/witt-machine-the-naughty-9-9mm-ultra-compact-suppr9-150x192.jpg',
    ],
    description: 'The Naughty 9 is our 9mm ultra compact suppressor. Perfect for Glock 9mm, MP5, PCC builds, and anything in between. Compact enough for everyday carry rigs, durable enough for sustained fire.',
    shortDesc: '9mm ultra compact suppressor for pistols and PCCs.',
    specs: {
      'Caliber': '9mm / 9x19',
      'NFA Item': 'Yes — All NFA Rules Apply',
      'Mounting': 'Direct Thread',
      'Type': 'Ultra Compact',
      'Finish Options': 'Cerakote / Stainless',
      'Material': 'Stainless Steel',
    },
    features: [
      'Optimized for 9mm subsonic ammo',
      'Compatible with most threaded 9mm barrels',
      'Ultra compact form factor',
      'Durable stainless construction',
    ],
    useCases: ['Home Defense', 'Tactical', 'Range', 'EDC'],
    inStock: true,
    featured: false,
    nfaItem: true,
    shippingNote: '*Choose UPS Shipping at Checkout*',
  },
  {
    id: 'canooter-valve',
    slug: 'canooter-valve-suppressor',
    name: 'Canooter Valve',
    subtitle: 'Compact Suppressor',
    category: 'suppressors',
    price: 248.75,
    priceRange: null,
    rating: 4.7,
    reviewCount: 18,
    badge: 'Best Price',
    image: 'https://wittmachine.net/wp-content/uploads/2025/09/canooter-valve-suppressor.webp',
    images: [
      'https://wittmachine.net/wp-content/uploads/2025/09/canooter-valve-suppressor.webp',
      'https://wittmachine.net/wp-content/uploads/2022/08/witt-machine-canooter-valve-compact-suppressor-150x192.jpg',
    ],
    description: 'The Canooter Valve brings NFA suppressor performance at the most accessible price point in the Witt Machine lineup. A practical compact suppressor for the budget-conscious shooter who refuses to compromise on hearing protection.',
    shortDesc: 'Our most affordable compact suppressor — maximum value, real NFA performance.',
    specs: {
      'NFA Item': 'Yes — All NFA Rules Apply',
      'Mounting': 'Direct Thread',
      'Type': 'Compact',
      'Finish Options': 'Cerakote / Stainless',
      'Material': 'Stainless Steel',
    },
    features: [
      'Best value in the suppressor lineup',
      'Real NFA-registered suppressor',
      'Compact and lightweight design',
      'Stainless steel construction',
    ],
    useCases: ['Range', 'Hunting', 'Home Defense'],
    inStock: true,
    featured: false,
    nfaItem: true,
    shippingNote: '*Choose UPS Shipping at Checkout*',
  },

  // ===== SME =====
  {
    id: 'ak47-sme',
    slug: 'ak47-sme-sound-mitigation',
    name: 'AK47 SME',
    subtitle: 'Sound Mitigation Equipment',
    category: 'sme',
    price: 175.00,
    priceRange: null,
    rating: 4.9,
    reviewCount: 21,
    badge: null,
    image: 'https://wittmachine.net/wp-content/uploads/2025/09/sound.webp',
    images: [
      'https://wittmachine.net/wp-content/uploads/2025/09/sound.webp',
      'https://wittmachine.net/wp-content/uploads/2022/08/witt-machine-ak47-sme-sound-mitigation-equipment-150x192.jpg',
    ],
    description: 'The AK47 SME (Sound Mitigation Equipment) is a non-NFA blast director for AK pattern rifles. It directs the blast and sound forward, away from the shooter and those nearby, without suppressing the report. No NFA paperwork, no wait.',
    shortDesc: 'Non-NFA blast director for AK47 — redirects sound forward, no registration required.',
    specs: {
      'Platform': 'AK-47 Pattern',
      'NFA Item': 'NO — No Registration Required',
      'Type': 'Sound Mitigation Equipment',
      'Mounting': 'Barrel-specific (threaded)',
      'Material': 'Stainless Steel',
    },
    features: [
      'NO NFA registration required',
      'Directs blast and sound forward',
      'Reduces perceived noise to shooter',
      'AK-47 platform specific',
      'Made in Texas, USA',
    ],
    useCases: ['Tactical', 'Range', 'AK Platform'],
    inStock: true,
    featured: false,
    nfaItem: false,
  },
  {
    id: 'sme-slimline',
    slug: 'sme-slimline',
    name: 'SME Slimline',
    subtitle: 'Sound Mitigation Equipment',
    category: 'sme',
    price: 175.00,
    priceRange: null,
    rating: 5.0,
    reviewCount: 16,
    badge: null,
    image: 'https://wittmachine.net/wp-content/uploads/2025/09/sound.webp',
    images: [
      'https://wittmachine.net/wp-content/uploads/2025/09/sound.webp',
      'https://wittmachine.net/wp-content/uploads/2022/08/witt-machine-sme-sound-mitigation-equipment-slimli-150x192.jpg',
    ],
    description: 'The SME Slimline is our slim-profile Sound Mitigation Equipment. A low-profile, non-NFA blast direction device that keeps your setup streamlined while directing sound and blast forward away from the shooter.',
    shortDesc: 'Low-profile non-NFA blast director — slim, effective, no paperwork.',
    specs: {
      'NFA Item': 'NO — No Registration Required',
      'Type': 'Sound Mitigation Equipment',
      'Profile': 'Slimline / Low Profile',
      'Material': 'Stainless Steel',
    },
    features: [
      'NO NFA registration required',
      'Slimline low-profile design',
      'Directs blast forward',
      'Reduces concussive effect on shooter',
    ],
    useCases: ['Range', 'Tactical', 'Hunting'],
    inStock: true,
    featured: false,
    nfaItem: false,
  },

  // ===== CLAMP-ONS =====
  {
    id: 'custom-clamp-on',
    slug: 'custom-clamp-on-muzzle-brake',
    name: 'Custom Clamp-On Muzzle Brake',
    subtitle: 'No Threading Required',
    category: 'clamp-ons',
    price: 99.00,
    priceRange: '$99 – $114',
    rating: 4.8,
    reviewCount: 44,
    badge: 'Custom Made',
    image: 'https://wittmachine.net/wp-content/uploads/2025/09/custombrake.webp',
    images: [
      'https://wittmachine.net/wp-content/uploads/2025/09/custombrake.webp',
    ],
    description: 'Our custom clamp-on muzzle brake attaches to virtually any smooth barrel without threading. Supply your caliber and barrel measurements and we machine it to fit. Approximately 60% recoil reduction and muzzle rise elimination. Made to order in Texas.',
    shortDesc: 'Custom-fit clamp-on brake — no threading needed, 60%+ recoil reduction.',
    specs: {
      'Type': 'Clamp-On (No Threading)',
      'Recoil Reduction': '~60%',
      'Length': '~3.5 inches',
      'Barrel Compatibility': 'Most smooth barrels up to 1+ inch diameter',
      'Finishes': 'Stainless / Cerakote Black / FDE',
      'Weight': '6–9 oz (barrel diameter dependent)',
    },
    features: [
      'No barrel threading required',
      '~60% recoil reduction',
      'Custom-machined to your barrel specs',
      'Available in Cerakote black, FDE, or natural stainless',
      'Made to order in Texas',
    ],
    useCases: ['Hunting', 'Range', 'Precision Shooting'],
    inStock: true,
    featured: true,
    nfaItem: false,
    variants: ['Stainless', 'Cerakote Black', 'FDE'],
  },
  {
    id: 'clamp-on-shotgun',
    slug: 'clamp-on-shotgun-brake',
    name: 'Clamp-On Shotgun Brake',
    subtitle: 'Shotgun Recoil Control',
    category: 'clamp-ons',
    price: 115.00,
    priceRange: '$115 – $130',
    rating: 4.9,
    reviewCount: 27,
    badge: null,
    image: 'https://wittmachine.net/wp-content/uploads/2025/09/shotgunbrake.webp',
    images: [
      'https://wittmachine.net/wp-content/uploads/2025/09/shotgunbrake.webp',
    ],
    description: 'Tame shotgun recoil without barrel modification. The Clamp-On Shotgun Brake is custom-machined to your barrel diameter and reduces recoil and muzzle rise significantly on any smooth-barrel shotgun.',
    shortDesc: 'Custom clamp-on muzzle brake for shotguns — no gunsmithing required.',
    specs: {
      'Platform': 'Shotgun (smooth barrel)',
      'Type': 'Clamp-On',
      'Recoil Reduction': '~60%',
      'Finishes': 'Stainless / Cerakote Black / FDE',
    },
    features: [
      'No barrel modification needed',
      'Custom-fit to your barrel diameter',
      'Dramatically reduces shotgun recoil',
      'Works on pump, semi-auto, and single shot shotguns',
    ],
    useCases: ['Hunting', 'Home Defense', '3-Gun'],
    inStock: true,
    featured: false,
    nfaItem: false,
  },
  {
    id: 'clamp-on-adapter',
    slug: 'custom-clamp-on-threaded-adapter',
    name: 'Clamp-On Threaded Adapter',
    subtitle: 'Add Threading Without Gunsmithing',
    category: 'clamp-ons',
    price: 125.00,
    priceRange: null,
    rating: 4.7,
    reviewCount: 19,
    badge: null,
    image: 'https://wittmachine.net/wp-content/uploads/2025/09/adapter.webp',
    images: [
      'https://wittmachine.net/wp-content/uploads/2025/09/adapter.webp',
      'https://wittmachine.net/wp-content/uploads/2022/08/witt-machine-custom-clamp-on-threaded-adapter-150x192.jpg',
    ],
    description: 'The Custom Clamp-On Threaded Adapter clamps onto your unthreaded barrel and adds a threaded muzzle — allowing you to run any standard thread-on muzzle device or suppressor. Custom-machined to your barrel diameter and desired thread pitch.',
    shortDesc: 'Add any thread pitch to an unthreaded barrel — no gunsmith required.',
    specs: {
      'Type': 'Clamp-On Threaded Adapter',
      'Thread Options': 'Most standard imperial and metric threads',
      'Material': 'Stainless Steel',
      'Finishes': 'Stainless / Cerakote Black',
    },
    features: [
      'Adds threading to any smooth barrel',
      'Custom thread pitch options',
      'No permanent barrel modification',
      'Enables suppressor use on unthreaded barrels',
    ],
    useCases: ['Hunting', 'Tactical', 'Suppressor Mounting'],
    inStock: true,
    featured: false,
    nfaItem: false,
  },

  // ===== MUZZLE DEVICES =====
  {
    id: '30cal-mre',
    slug: '30-cal-muzzle-rise-eliminator',
    name: '.30 Cal Muzzle Rise Eliminator',
    subtitle: 'Threaded Muzzle Brake',
    category: 'muzzle-devices',
    price: 99.00,
    priceRange: '$99 – $114',
    rating: 5.0,
    reviewCount: 52,
    badge: 'Top Rated',
    image: 'https://wittmachine.net/wp-content/uploads/2022/08/30-cal-muzzle-rise-eliminator-muzzle-brake5.jpg',
    images: [
      'https://wittmachine.net/wp-content/uploads/2022/08/30-cal-muzzle-rise-eliminator-muzzle-brake5.jpg',
    ],
    description: 'The .30 Cal Muzzle Rise Eliminator (MRE) has been independently tested to virtually eliminate muzzle rise for follow-up shots. Available in a wide range of thread pitches. Custom-machined to order in Texas.',
    shortDesc: 'Independently tested to virtually eliminate muzzle rise on .30 cal platforms.',
    specs: {
      'Caliber': '.30 Caliber',
      'Type': 'Threaded Muzzle Brake / MRE',
      'Thread Options': '5/8-24, 3/4-24 and others',
      'Recoil Reduction': '~60%',
      'Finishes': 'Stainless / Cerakote Black / FDE',
      'Material': 'Stainless Steel',
    },
    features: [
      'Virtually eliminates muzzle rise',
      '~60% recoil reduction',
      'Wide thread pitch selection',
      'Custom-machined to order',
      'Seen at SHOT Show Industry Day',
    ],
    useCases: ['Range', 'Hunting', 'Precision Shooting', 'Tactical'],
    inStock: true,
    featured: true,
    nfaItem: false,
  },
  {
    id: '65mm-mre',
    slug: '65mm-muzzle-rise-eliminator',
    name: '6.5mm Muzzle Rise Eliminator',
    subtitle: '5/8-24 Barrel Thread',
    category: 'muzzle-devices',
    price: 99.00,
    priceRange: '$99 – $114',
    rating: 4.9,
    reviewCount: 31,
    badge: null,
    image: 'https://wittmachine.net/wp-content/uploads/2025/09/6.5mm.webp',
    images: ['https://wittmachine.net/wp-content/uploads/2025/09/6.5mm.webp'],
    description: 'The 6.5mm Muzzle Rise Eliminator is precision-made for the growing popularity of 6.5mm platforms including 6.5 Creedmoor. The 5/8-24 thread pitch is the standard for most 6.5mm rifles.',
    shortDesc: 'Precision MRE brake for 6.5mm Creedmoor and similar platforms.',
    specs: {
      'Caliber': '6.5mm',
      'Thread Pitch': '5/8-24',
      'Recoil Reduction': '~60%',
      'Finishes': 'Stainless / Cerakote Black / FDE',
      'Material': 'Stainless Steel',
    },
    features: [
      'Optimized for 6.5 Creedmoor',
      'Standard 5/8-24 thread pitch',
      'Virtually eliminates muzzle rise',
      'Competition-tested performance',
    ],
    useCases: ['Precision Shooting', 'Hunting', 'Long Range'],
    inStock: true,
    featured: false,
    nfaItem: false,
  },
  {
    id: 'ak47-mre',
    slug: 'ak47-muzzle-rise-eliminator',
    name: 'AK47 Muzzle Rise Eliminator',
    subtitle: 'Threaded Muzzle Brake',
    category: 'muzzle-devices',
    price: 99.00,
    priceRange: '$99 – $114',
    rating: 4.9,
    reviewCount: 28,
    badge: null,
    image: 'https://wittmachine.net/wp-content/uploads/2025/09/ak47.webp',
    images: ['https://wittmachine.net/wp-content/uploads/2025/09/ak47.webp'],
    description: 'The AK47 Muzzle Rise Eliminator is machined for standard AK-pattern thread pitches including M14-1 and left-hand thread variants. Tame your AK47\'s notorious muzzle rise for faster follow-up shots.',
    shortDesc: 'MRE muzzle brake engineered specifically for AK-47 platform thread pitches.',
    specs: {
      'Platform': 'AK-47 Pattern',
      'Thread Options': 'M14-1, M14-1 LH',
      'Recoil Reduction': '~60%',
      'Finishes': 'Stainless / Cerakote Black / FDE',
      'Material': 'Stainless Steel',
    },
    features: [
      'AK-47 specific thread pitches',
      'Virtually eliminates AK muzzle rise',
      'Left-hand thread option available',
      'Cerakote finish matches most AK barrels',
    ],
    useCases: ['Range', 'Tactical', 'AK Platform'],
    inStock: true,
    featured: false,
    nfaItem: false,
  },
  {
    id: 'ar15-mre',
    slug: 'ar15-muzzle-rise-eliminator',
    name: 'AR15 Muzzle Rise Eliminator',
    subtitle: '.223/5.56 Muzzle Brake',
    category: 'muzzle-devices',
    price: 88.00,
    priceRange: '$88 – $104',
    rating: 5.0,
    reviewCount: 61,
    badge: 'On Sale',
    image: 'https://wittmachine.net/wp-content/uploads/2025/09/ar15.webp',
    images: ['https://wittmachine.net/wp-content/uploads/2025/09/ar15.webp'],
    description: 'The AR15 MRE (.223/5.56) is our most popular threaded muzzle brake. Independently tested and demonstrated at SHOT Show Industry Day — the sights just sit there through rapid fire. Available in 1/2-28 thread pitch, the AR-15 standard.',
    shortDesc: 'The most popular Witt MRE — as seen at SHOT Show Industry Day.',
    specs: {
      'Caliber': '.223 / 5.56',
      'Thread Pitch': '1/2-28',
      'Recoil Reduction': '~60%',
      'Finishes': 'Stainless / Cerakote Black / FDE',
      'Material': 'Stainless Steel',
    },
    features: [
      'Most popular Witt Machine brake',
      'Demonstrated at SHOT Show Industry Day',
      '"Sights just sit there" through rapid fire',
      'Standard 1/2-28 thread pitch',
    ],
    useCases: ['Range', 'Tactical', 'Competition', '3-Gun'],
    inStock: true,
    featured: true,
    nfaItem: false,
  },
  {
    id: 'custom-threaded',
    slug: 'custom-threaded-muzzle-brake',
    name: 'Custom Threaded Muzzle Brake',
    subtitle: 'Made to Your Specs',
    category: 'muzzle-devices',
    price: 99.00,
    priceRange: '$99 – $114',
    rating: 4.9,
    reviewCount: 35,
    badge: 'Custom Made',
    image: 'https://wittmachine.net/wp-content/uploads/2025/09/customthreaded.webp',
    images: ['https://wittmachine.net/wp-content/uploads/2025/09/customthreaded.webp'],
    description: 'Need a thread pitch we don\'t have listed? The Custom Threaded Muzzle Brake is machined to your exact specifications. Available in imperial and metric threads — from 1/2-20 and 9/16-28 to M15-1 and M18-1.',
    shortDesc: 'Custom-machined threaded muzzle brake in any imperial or metric thread pitch.',
    specs: {
      'Type': 'Custom Threaded Muzzle Brake',
      'Thread Options': 'Most imperial & metric threads available',
      'Recoil Reduction': '~60%',
      'Finishes': 'Stainless / Cerakote Black / FDE',
      'Material': 'Stainless Steel',
    },
    features: [
      'Any imperial or metric thread pitch',
      'Imperial: 1/2-20, 1/2-28, 9/16-24, 5/8-24, 3/4-24 and more',
      'Metric: M14-1, M15-.75, M15-1, M18-1 and more',
      'Made to order in Texas',
    ],
    useCases: ['Hunting', 'Range', 'Precision Shooting', 'Custom Builds'],
    inStock: true,
    featured: false,
    nfaItem: false,
  },
];

export const FEATURED_PRODUCTS = PRODUCTS.filter(p => p.featured);

export const getProductsByCategory = (categorySlug) => {
  const catMap = {
    'suppressors': 'suppressors',
    'sound-mitigation-equipment': 'sme',
    'clamp-ons': 'clamp-ons',
    'muzzle-devices': 'muzzle-devices',
  };
  const catId = catMap[categorySlug] || categorySlug;
  return PRODUCTS.filter(p => p.category === catId);
};

export const getProductBySlug = (slug) => PRODUCTS.find(p => p.slug === slug);

export const TESTIMONIALS = [
  {
    id: 1,
    author: 'Alex',
    text: "I'm so impressed with the performance of this can on my 12.5 5.56 SBR. Hearing safe, half the size, and half the cost of other cans on the market. Pick up one of these babies. No brainer.",
    product: 'Mod-1 Quick Disconnect',
    rating: 5,
  },
  {
    id: 2,
    author: 'Scoot',
    text: "Probably my favorite can now. Compact easy to maneuver on SBR and hearing safe on my 11.5 5.56. I absolutely love this thing so much I'm gonna have to get another for my 14.5.",
    product: 'Mod-1 Quick Disconnect',
    rating: 5,
  },
  {
    id: 3,
    author: 'Brandon',
    text: "I have run this can from a .22lr pistol to 204 Ruger AR15 and .223 Remington bolt and AR platform. It's worth the money for hearing safety.",
    product: 'Suppressors',
    rating: 5,
  },
  {
    id: 4,
    author: 'William',
    text: 'I just purchased a fourth MRE today. Very well engineered design, keep up the good work. I will probably outfit most of my non-suppressed weapon systems with an MRE.',
    product: 'AR15 MRE',
    rating: 5,
  },
  {
    id: 5,
    author: 'Tim',
    text: 'Installed their brake on my Ruger Precision Rifle to try and stop the muzzle flip. It stopped at least 80 percent. Would highly recommend these to stop flip on rifles.',
    product: '6.5mm MRE',
    rating: 5,
  },
  {
    id: 6,
    author: 'Jenna C.',
    text: 'Ordered Witt Machine & Tool SME with 1/2-28 thread. It was promptly shipped and received in about a week. Everything is great.',
    product: 'SME Slimline',
    rating: 5,
  },
];
